import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import { tokens } from "../../../../theme";
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import ShLabel from "../../../theme/label/ShLabel";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { getOrderStateData } from "../../../../utils/labelColorText";
import { useSelector } from "react-redux";
import { ENV_TYPES } from "../../Sidebar";
import { calculateBusinessDays, getDaysColorVariant } from "../../../../environments/warehouse/outbound/orders/views/Bol";
import Subheading from "../../../theme/text/Subheading";

const BolLvbCard = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [statusColor, setStatusColor] = useState("blue");
    const [statusText, setStatusText] = useState("");
    const [businessDays, setBusinessDays] = useState(null);


    let labelcolor = "grey";
    let expected = props.expectedDeliveryDate ? new Date(props.expectedDeliveryDate) : null;
    let planned = props.plannedShipmentDate ? new Date(props.plannedShipmentDate) : null;
  
    if(planned) {

            labelcolor = "green";
      
    }
    else if(expected) {
        // When sent is not filled and planned >= now: blue
        if(expected.getTime() >= Date.now()) {
            labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
        }
        // When sent is not filled and planned < now: red
        else if(expected.getTime() < Date.now()) {
            labelcolor = "red";
        }
    } else {
        labelcolor = "grey";    
    }
    
    useEffect(() => {
        // console.log("skellytime",props.skeleton);
        if(!props.skeleton) {
            switch(props.state) {
                case "open":
                    setStatusColor("grey")
                    setStatusText(t("open"))
                    break;
                case "approved":
                    setStatusColor(theme.palette.mode === "dark" ? "blue" : "primary")
                    setStatusText(t("approved"))
                    break;
                case "rejected":
                    setStatusColor("red")
                    setStatusText(t("rejected"))
                    break;
                case "completed":
                    setStatusColor("green")
                    setStatusText(t("completed"))
                    break;
                default:
                    setStatusColor("orange")
                    setStatusText(t("unknown"))
            }
            setBusinessDays(calculateBusinessDays(props.createdAt));
        }

    },[props.skeleton])

   

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box
                >
                    <Box display={"flex"} flexDirection={"column"}>
                        {props.skeleton ? 
                            <ShDoubleTextSkeleton/> 
                            :
                            <>
                                <Text black>{props.reference ?? props.barcode ?? props.id}</Text>
                                <Text>{props.relation?.name}</Text>
                                <Text light>{props.webshopcredentials?.description ?? t("self_created")}</Text>
                            </>
                        }
                    </Box>
                    <TopRight>
                        <CardLabel 
                            variant={props.skeleton ? "grey" : statusColor}  
                            position="child-tr"
                            hasright={props.state === "open"}
                        >
                            {statusText}
                        </CardLabel>
                        {props.state === "open" &&
                        
                            <CardLabel 
                                hasleft 
                                background={theme.palette.mode === "dark" ?  colors.txt["secondary"] : null} 
                                color={theme.palette.mode === "dark" ? colors.txt["primary"] : null} 
                                variant={businessDays !== null ? getDaysColorVariant(businessDays) : theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                position="child-tr"
                            >
                                {props.skeleton ? null :
                                   businessDays
                                }
                            </CardLabel>
                        
                        }
                    </TopRight>

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} gap={3} overflow={"hidden"}>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("products")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Subheading noBreak>
                                    {props.amountOfLines}
                                </Subheading>
                            }
                        </Box>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("items")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Subheading noBreak>
                                    {props.amountOfItems}
                                </Subheading>
                            }
                        </Box>
                        
                        <Box display={"flex"} flexDirection={"column"} ml="auto">
                            <Text noBreak light>{props.state === "open" ? t("date_created") : t("deliverydates")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                props.state === "open" ?
                                    <Box>

                                        <Text semibold>{new Date(props.createdAt).toLocaleDateString(i18n.language, { dateStyle: 'short' })}</Text>&nbsp;&nbsp;
                                        <Text>{new Date(props.createdAt).toLocaleTimeString(i18n.language, { timeStyle: 'short' })}</Text>
                                    </Box>
                                :

                                    <ShLabel size={24} borderless fitted variant={labelcolor} palette="normal">
                                    {!planned && expected.toLocaleDateString(i18n.language)}
                                    {planned && planned.toLocaleDateString(i18n.language)}
                                </ShLabel>
                            }
                        </Box>

                    </Box>

                    
                </Box>
            </Box>
        </BaseCard>
    )
}

export const BolLvbRelationCard = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const [statusColor, setStatusColor] = useState("blue");
    const [statusText, setStatusText] = useState("");


    let labelcolor = "grey";
    let expected = props.expectedDeliveryDate ? new Date(props.expectedDeliveryDate) : null;
    let planned = props.plannedShipmentDate ? new Date(props.plannedShipmentDate) : null;
  
    if(planned) {

            labelcolor = "green";
      
    }
    else if(expected) {
        // When sent is not filled and planned >= now: blue
        if(expected.getTime() >= Date.now()) {
            labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
        }
        // When sent is not filled and planned < now: red
        else if(expected.getTime() < Date.now()) {
            labelcolor = "red";
        }
    } else {
        labelcolor = "grey";    
    }
    
    useEffect(() => {
        // console.log("skellytime",props.skeleton);
        if(!props.skeleton) {
            switch(props.state) {
                case "open":
                    setStatusColor("grey")
                    setStatusText(t("open"))
                    break;
                case "approved":
                    setStatusColor(theme.palette.mode === "dark" ? "blue" : "primary")
                    setStatusText(t("approved"))
                    break;
                case "rejected":
                    setStatusColor("red")
                    setStatusText(t("rejected"))
                    break;
                case "completed":
                    setStatusColor("green")
                    setStatusText(t("completed"))
                    break;
                default:
                    setStatusColor("orange")
                    setStatusText(t("unknown"))
            }
        }

    },[props.skeleton])

   

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box
                >
                    <Box display={"flex"} flexDirection={"column"}>
                        {props.skeleton ? 
                            <ShDoubleTextSkeleton/> 
                            :
                            <>
                                <Text black>{props.reference ?? props.barcode ?? props.id}</Text>
                                <Text>{props.relation?.name}</Text>
                                <Text light>{props.webshopcredentials?.description ?? t("self_created")}</Text>
                            </>
                        }
                    </Box>
                    <TopRight>
                        <CardLabel 
                            variant={props.skeleton ? "grey" : statusColor}  
                            position="child-tr"
                        >
                            {statusText}
                        </CardLabel>
                    </TopRight>

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} gap={3} overflow={"hidden"}>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("products")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Subheading noBreak>
                                    {props.amountOfLines}
                                </Subheading>
                            }
                        </Box>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("items")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Subheading noBreak>
                                    {props.amountOfItems}
                                </Subheading>
                            }
                        </Box>

                        {props.state !== "open" &&
                            <Box display={"flex"} flexDirection={"column"} ml="auto">
                                <Text noBreak light>{t("deliverydates")}</Text>

                                {props.skeleton ?
                                    <ShTextSkeleton />
                                    :
                                        <ShLabel size={24} borderless fitted variant={labelcolor} palette="normal">
                                        {!planned && expected.toLocaleDateString(i18n.language)}
                                        {planned && planned.toLocaleDateString(i18n.language)}
                                    </ShLabel>
                                }
                            </Box>
                        }

                    </Box>

                    
                </Box>
            </Box>
        </BaseCard>
    )
}

export default BolLvbCard;